import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import ChartJS from 'chart.js';

export default function Chart({ stats }) {
    const [chart, setChart] = useState({});
    const chartRef = useRef(null);
    
    const updateChart = (_chart, _labels, _datasets) => {
        _chart.data.labels = _labels;
        _chart.data.datasets = _datasets;

        _chart.options.scales.yAxes = [{
            stacked: true,
        }];

        _chart.update(0);

        return chart;
    };

    const createChart = (_labels, _datasets) => {
        const ctx = chartRef.current.getContext('2d');
        const __chart = new ChartJS(ctx, {
            type: 'bar',
            data: {
                labels: _labels,
                datasets: _datasets,
            },
            options: {
                tooltips: {
                    mode: 'label',
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                    }],
                },
            },
        });

        return __chart;
    };

    const populateChart = (_stats = []) => {
        const vessels = [];
        const sizes = [];
        const labels = [];

        _stats.forEach((stat) => {
            labels.push(stat.date);
            vessels.push(stat.vessels);
            sizes.push(stat.sizes);
        });

        const datasets = [
            {
                label: 'Vessels',
                data: vessels,
                borderColor: 'red',
                backgroundColor: 'salmon',
                stack: 'combined',
                type: 'bar',
            },
            {
                label: 'Sizes',
                data: sizes,
                borderColor: 'blue',
                stack: 'combined',
                type: 'line',
            },
        ];

        if (_.isEmpty(chart)) {
            setChart(createChart(labels, datasets));
        } else {
            setChart(updateChart(chart, labels, datasets));
        }
    };

    useEffect(() => {
        populateChart(stats);   
    }, [stats]);

    useEffect(() => {
        populateChart();
    }, []);

    return (
        <div className='row'>
            <div className='col-xs-12'>
                <canvas ref={chartRef} />
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Statistics/Composition/Chart.jsx